import React from "react";
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  TableFooter
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
  getFontSize(columnCount, isHeader = false) {
    const maxFontSize = isHeader ? 14 : 16;
    const minFontSize = 10;

    let fontSize = maxFontSize;

    if (columnCount >= 31) {
      fontSize = minFontSize;
    } else if (columnCount > 5) {
      fontSize = Math.max(minFontSize, maxFontSize - Math.floor((columnCount - 5) * 2));
    }
    return fontSize;
  }

  render() {
    const { selectedSearchValues, cropSupplyDetails, monthDays } = this.props;
    const options = {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    const columnCount = monthDays.length + 3;
    return (
      <div style={{ width: '100%' }}>
        <h2><center><u>Crop Supply Monthly Report</u></center></h2>
        <div>&nbsp;</div>
        <h4><center>Group - {selectedSearchValues.groupName} </center></h4>
        <div></div>
        <h4><center>Factory - {selectedSearchValues.factoryName}</center></h4>
        <div></div>
        <h4><center>Route - {selectedSearchValues.routeName}</center></h4>
        <div></div>
        <h4><center>Registration Number - {selectedSearchValues.registrationNumber}</center></h4>
        <div></div>
        <h4><center>Month- {selectedSearchValues.startDate}</center></h4>
        <div>&nbsp;</div>
        <br></br>
        <div>
          <Table size="small" aria-label="simple table" style={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                {["Route", "Reg.No", "Customer", ...monthDays.map(day => moment(day).format('DD')), "Total"].map((header, index) => (
                  <TableCell
                    key={index}
                    style={{
                      border: "1px solid black",
                      fontWeight: "bold",
                      fontSize: `${this.getFontSize(columnCount, true)}px`,
                      padding: '4px',
                      whiteSpace: 'normal',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      textAlign: 'center'
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {cropSupplyDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ border: "1px solid black", padding: '4px', fontSize: `${this.getFontSize(columnCount)}px`, whiteSpace: 'normal' }} align="left" component="th" scope="row">
                    {row.routeName}
                  </TableCell>
                  <TableCell style={{ border: "1px solid black", padding: '4px', fontSize: `${this.getFontSize(columnCount)}px`, whiteSpace: 'normal' }} align="left">
                    {row.registrationNumber}
                  </TableCell>
                  <TableCell style={{ border: "1px solid black", padding: '4px', fontSize: `${this.getFontSize(columnCount)}px`, whiteSpace: 'normal' }} align="left">
                    {row.name}
                  </TableCell>
                  {monthDays.map((day, dayIndex) => {
                    const found = row.groupList.find(x => x.cropCollectedDate === day);
                    return (
                      <TableCell key={dayIndex} style={{ border: "1px solid black", padding: '4px', fontSize: `${this.getFontSize(columnCount)}px`, whiteSpace: 'normal', overflow: 'hidden' }} align="right">
                        {found ? (found.cropWeight).toLocaleString('en-US', options) : '-'}
                      </TableCell>
                    );
                  })}
                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", alignContent: "left", padding: '4px', fontSize: `${this.getFontSize(columnCount)}px`, whiteSpace: 'normal' }} align="right">
                    {(row.totalAmount).toLocaleString('en-US', options)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableRow>
              <TableCell colSpan={3} style={{ border: "1px solid black", fontWeight: "bold", fontSize: `${this.getFontSize(columnCount)}px`, color: "red", padding: '4px', whiteSpace: 'normal' }} align="center">
                Total
              </TableCell>
              {monthDays.map((day, index) => {
                const dayTotal = cropSupplyDetails.reduce((total, row) => {
                  const found = row.groupList.find(x => x.cropCollectedDate === day);
                  return total + (found ? parseFloat(found.cropWeight) : 0);
                }, 0).toLocaleString('en-US', options);
                return (
                  <TableCell key={index} style={{ border: "1px solid black", fontWeight: "bold", fontSize: `${this.getFontSize(columnCount)}px`, color: "red", padding: '4px', whiteSpace: 'normal' }} align="right">
                    {dayTotal !== 0 ? dayTotal : '-'}
                  </TableCell>
                );
              })}
              <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: `${this.getFontSize(columnCount)}px`, color: "red", padding: '4px', whiteSpace: 'normal' }} align="right">
                {cropSupplyDetails.reduce((total, row) => total + parseFloat(row.totalAmount), 0).toLocaleString('en-US', options)}
              </TableCell>
            </TableRow>
          </Table>
        </div>
        <div>&nbsp;</div>
      </div>
    );
  }
}  